module.exports = __webpack_public_path__ + "static/media/Corteva_How_the_world_grows_TMT-CORT003-120-desktop.22c27472.jpg";